import Cookies from 'js-cookie'
import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { redirectToAuth, refreshToken, setVerifiedUser, trackLogout } from './utils'


const AUTH_FAILED_STATUE_CODES = [401]

export async function setupAuth() {

  axios.interceptors.request.use(
    config => {
      const accessToken = Cookies.get('miigu__auth__access_token')
      if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  createAuthRefreshInterceptor(axios, refreshToken, { statusCodes: AUTH_FAILED_STATUE_CODES })

  await setVerifiedUser()

  axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (AUTH_FAILED_STATUE_CODES.includes(error.response?.status)) {
        redirectToAuth()
      } else {
        return Promise.reject(error)
      }
    }
  )

  trackLogout()
}
